var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-phone",
    "data-name": "Icon awesome-phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.282,
    height: 16.282,
    viewBox: "0 0 16.282 16.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-2",
    "data-name": "Icon awesome-phone",
    d: "M15.69.782,12.383.019a.768.768,0,0,0-.875.442L9.982,4.022a.761.761,0,0,0,.219.89L12.128,6.49a11.786,11.786,0,0,1-5.635,5.635L4.916,10.2a.762.762,0,0,0-.89-.219L.464,11.505a.772.772,0,0,0-.445.878L.782,15.69a.763.763,0,0,0,.744.591A14.754,14.754,0,0,0,16.281,1.526.762.762,0,0,0,15.69.782Z",
    transform: "translate(0.001 0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8d82ed3f83e638113d3113a40cda4b9f.svg";
export { ForwardRef as ReactComponent };